export function deepClone(data) {
  const type = metaType(data);
  let obj = null;
  if (type === "array") {
    obj = [];
    for (let i = 0; i < data.length; i++) {
      obj.push(deepClone(data[i]));
    }
  } else if (type === "object") {
    obj = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        obj[key] = deepClone(data[key]);
      }
    }
  } else {
    return data;
  }
  return obj;
}

// 匹配函数
function metaType(obj) {
  const MAP = {
    "[object String]": "string",
    "[object Number]": "number",
    "[object Boolean]": "boolean",
    "[object Null]": "null",
    "[object Undefined]": "undefined",
    "[object Symbol]": "symbol",
    "[object BigInt]": "bigInt",
    "[object Object]": "object",
    "[object Function]": "function",
    "[object Array]": "array",
    "[object Date]": "date",
    "[object RegExp]": "regExp",
    "[object Error]": "error",
  };

  return MAP[Object.prototype.toString.call(obj)];
}
